<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 md6>
        <UserInfos />
      </v-flex>
      <v-flex xs12 md6>
        <UserPassword />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { fetchHil } from "../utils";
import moment from "moment";
import UserInfos from "../components/user/UserInfos";
import UserPassword from "../components/user/UserPassword";

export default {
  components: { UserPassword, UserInfos },
  data() {
    return {
      user: null
    };
  },

  computed: {
    cleanBirthDate: function() {
      let v = this.user.birthday;
      if (v == null) {
        return v;
      }
      return moment(String(v)).format("DD/MM/YYYY");
    }
  },

  async mounted() {
    const resp = await fetchHil("/user/info");
    this.user = await resp.json();
  }
};
</script>
<style></style>
